:host {
  display: block;
  width: 100%;
  padding: 8px 0;
}
